import { getAgentYearbookSummaries,
  generateAgentYearbookImage,
  generateAgentYearbookVoucher,
  yearbookGeneralData } from '~/api/agent-yearbook';

export const state = () => ({
  activeIndex: 0,
  YIRPages: [
    //  {
    //    index: 0,
    //    url: '/syukuran/sections',
    //    componentPath: './pages/index',
    //  },
    {
      index: 1,
      url: 'sections#undangan',
      componentPath: './sections/1.2-WartaMitra',
    },
    {
      index: 2,
      url: 'sections#lama-bergabung',
      componentPath: './sections/1.3-JoinBerangkat',
    },
    {
      index: 3,
      url: 'sections#keuntungan',
      componentPath: './sections/1.4-GosipTetangga',
    },
    {
      index: 4,
      url: 'sections#jualan',
      componentPath: './sections/1.5-BestProduk',
    },
    {
      index: 5,
      url: 'sections#pembeli',
      componentPath: './sections/1.6-Pelanggan',
    },
    {
      index: 6,
      url: 'sections#paling-laku',
      componentPath: './sections/1.7-TendaPecel',
    },
    {
      index: 7,
      url: 'sections#tulisan-truk',
      componentPath: './sections/1.8-Truck',
    },
    {
      index: 8,
      url: 'sections#hemat',
      componentPath: './sections/1.9-HematUntung',
    },
    {
      index: 9,
      url: 'sections#sampai',
      componentPath: './sections/1.10-PanggungHiburan',
    },
    {
      index: 10,
      url: 'sections#pengumuman',
      componentPath: './sections/1.11-CacaHandika',
    },
    {
      index: 11,
      url: 'sections#plakat',
      componentPath: './sections/1.12-MenerimaHadiah',
    },
  ],
  YIRImages: [
    '/images/yir2019/achievement_electricity.png',
    '/images/yir2019/achievement_grocery.png',
    '/images/yir2019/achievement_kuota.png',
    '/images/yir2019/achievement_pulsa.png',
    '/images/yir2019/achievement_tagihan.png',
    '/images/yir2019/achievement_transport.png',
    '/images/yir2019/best-produk.png.webp',
    '/images/yir2019/bubble-chat-1.png.webp',
    '/images/yir2019/bubble-chat-2.png.webp',
    '/images/yir2019/bubble-chat-3.png.webp',
    '/images/yir2019/bubble-chat-4.png.webp',
    '/images/yir2019/bubble-chat-5.png.webp',
    '/images/yir2019/bukalapak-birthday.png.webp',
    '/images/yir2019/caca-handika.png.webp',
    '/images/yir2019/gosip-tetangga.png.webp',
    '/images/yir2019/hemat.png.webp',
    '/images/yir2019/kode_mitra.png',
    '/images/yir2019/loading-dinihari.png.webp',
    '/images/yir2019/loading-malam.png.webp',
    '/images/yir2019/loading-pagi.png.webp',
    '/images/yir2019/loading-senja.png.webp',
    '/images/yir2019/loading-siang.png.webp',
    '/images/yir2019/menerima-hadiah.png.webp',
    '/images/yir2019/menu-paling-laku.png.webp',
    '/images/yir2019/o2o_menu_palinglakuantangin.png.webp',
    '/images/yir2019/o2o_menu_palinglakubaterai.png.webp',
    '/images/yir2019/o2o_menu_palinglakubedak.png.webp',
    '/images/yir2019/o2o_menu_palinglakuberas.png.webp',
    '/images/yir2019/o2o_menu_palinglakubuku.png.webp',
    '/images/yir2019/o2o_menu_palinglakugula.png.webp',
    '/images/yir2019/o2o_menu_palinglakukecap_saus.png.webp',
    '/images/yir2019/o2o_menu_palinglakulampu.png.webp',
    '/images/yir2019/o2o_menu_palinglakumie_instan.png.webp',
    '/images/yir2019/o2o_menu_palinglakuminuman_botol.png.webp',
    '/images/yir2019/o2o_menu_palinglakuminuman_kotak.png.webp',
    '/images/yir2019/o2o_menu_palinglakuminuman_renceng.png.webp',
    '/images/yir2019/o2o_menu_palinglakuminyak_bayi.png.webp',
    '/images/yir2019/o2o_menu_palinglakuminyak_goreng.png.webp',
    '/images/yir2019/o2o_menu_palinglakupembalut.png.webp',
    '/images/yir2019/o2o_menu_palinglakuperlengkapan_mandi.png.webp',
    '/images/yir2019/o2o_menu_palinglakupermen.png.webp',
    '/images/yir2019/o2o_menu_palinglakupopok.png.webp',
    '/images/yir2019/o2o_menu_palinglakupulpen.png.webp',
    '/images/yir2019/o2o_menu_palinglakurokok.png.webp',
    '/images/yir2019/o2o_menu_palinglakusabun_cuci.png.webp',
    '/images/yir2019/o2o_menu_palinglakusabun.png.webp',
    '/images/yir2019/o2o_menu_palinglakusandal.png.webp',
    '/images/yir2019/o2o_menu_palinglakushampoo.png.webp',
    '/images/yir2019/o2o_menu_palinglakusnack.png.webp',
    '/images/yir2019/o2o_menu_palinglakusuperpell.png.webp',
    '/images/yir2019/o2o_menu_palinglakutepung.png.webp',
    '/images/yir2019/o2o_menu_palinglakuwafer.png.webp',
    '/images/yir2019/panggung-hiburan.png.webp',
    '/images/yir2019/pelanggan.png.webp',
    '/images/yir2019/SalesVPCredit.png.webp',
    '/images/yir2019/tenda-pecel.png.webp',
    '/images/yir2019/trophy-electricity.png.webp',
    '/images/yir2019/trophy-grocery.png.webp',
    '/images/yir2019/trophy-kuota.png.webp',
    '/images/yir2019/trophy-pulsa.png.webp',
    '/images/yir2019/trophy-tagihan.png.webp',
    '/images/yir2019/trophy-transport.png.webp',
    '/images/yir2019/ulangtahun-bukalapak.png.webp',
    '/images/yir2019/untung.png.webp',
    '/images/yir2019/warmi-berangkat.png.webp',
    '/images/yir2019/warta-mitra.png.webp',
  ],
  agentYearbookSummaries: null,
  type: 'general',
  agentYearbookImage: null,
  toggle: false,
});

export const getters = {
  activeIndex: state => state.activeIndex,
  YIRPages: state => state.YIRPages,
  activeYIRPage: state => state.YIRPages[state.activeIndex],
  YIRImages: state => state.YIRImages,
  getAgentYearbookSummaries: state => state.agentYearbookSummaries,
  getGTProducts: state => (state.agentYearbookSummaries && state.agentYearbookSummaries.gt ? state.agentYearbookSummaries.gt.products : null),
  YIRType: state => state.type, // personal || general
  YIRSectionVP: state => state.agentYearbookSummaries && state.agentYearbookSummaries.flow && state.agentYearbookSummaries.flow.vp,
  YIRSectionGT: state => state.agentYearbookSummaries && state.agentYearbookSummaries.flow && state.agentYearbookSummaries.flow.gt,
  agentYearbookImage: state => state.agentYearbookImage,
  YIRToggle: state => state.toggle,
};

export const mutations = {
  setActiveIndex(state, index) {
    state.activeIndex = index;
  },
  setActiveByHash(state, hash) {
    const hashPages = state.YIRPages.find(k => k.url === `sections${hash}`) || state.YIRPages[0];
    state.activeIndex = hashPages.index;
    state.activeYIRPage = hashPages;
  },
  incActiveIndex(state) {
    if (state.activeIndex < state.YIRPages.length - 1) {
      state.activeIndex += 1;
    }
  },
  decActiveIndex(state) {
    if (state.activeIndex > 0) {
      state.activeIndex -= 1;
    }
  },
  setAgentYearbookSummaries(state, { agentYearbookSummaries,
    type }) {
    state.agentYearbookSummaries = agentYearbookSummaries;
    state.type = type;
  },
  setAgentYearbookImage(state, agentYearbookImage) {
    state.agentYearbookImage = agentYearbookImage;
  },
};

export const actions = {
  initActivePages({ commit }, hash) {
    commit('setActiveByHash', hash);
  },
  nextPage({ commit }) {
    commit('incActiveIndex');
  },
  prevPage({ commit }) {
    commit('decActiveIndex');
  },
  async fetchAgentYearbookSummaries({ commit }) {
    try {
      const response = await getAgentYearbookSummaries(this.$axios);
      if (!response || !response.meta || response.meta.http_status !== 200) throw response;
      commit('setAgentYearbookSummaries', {
        agentYearbookSummaries: response.data,
        type: 'personal',
      });
      return response;
    } catch (error) {
      if (error && error.meta && error.meta.http_status === 404) {
        commit('setAgentYearbookSummaries', {
          agentYearbookSummaries: yearbookGeneralData,
          type: 'general',
        });
        return error;
      }
      console.warn('[ERROR FETCH AGENT YEARBOOK SUMMARIES]', error.message || error);
      throw error;
    }
  },
  async fetchAgentYearbookImage({ commit }) {
    try {
      const response = await generateAgentYearbookImage(this.$axios);
      if (!response || !response.meta || response.meta.http_status !== 201) throw response;
      commit('setAgentYearbookImage', response.data);
      return response;
    } catch (error) {
      console.warn('[ERROR FETCH AGENT YEARBOOK IMAGE]', error.message || error);
      throw error;
    }
  },
  async createAgentYearbookVoucher(context) {
    try {
      const response = await generateAgentYearbookVoucher(this.$axios);
      if (!response || !response.meta || response.meta.http_status !== 201) throw response;
      return response;
    } catch (error) {
      if (error && error.meta && error.meta.http_status === 422) {
        return error;
      }
      console.warn('[ERROR FETCH AGENT YEARBOOK VOUCHER]', error.message || error);
      throw error;
    }
  },
};
